
export class ArticleImportModel {
  counter: number = 0;
  articleCode: number = 0;
  alterCode: string | null = null;
  alterCode2: string | null = null;
  name: string = "";
  familyCode: string = "";
  groupCode: string = "";
  subgroupCode: string = "";
  typeArticleId: number = 0;
  typeInventoryCode: number = 0;
  rentalUnitCode: string = "";
  inventoryUnitCode: string = "";
  occupancyPercentageReport: boolean = true;
  daysInConstructionSiteReport: boolean = true;
  weight: number = 0;
  areaM2: number = 0;
  observation: string | null = null;
  active: boolean = true;
  swAffectsInventory: boolean = true;
  swDirectDevolutionWorkshop: boolean = true;
  swEquipmentLogbook: boolean = true;
  replacementValue: number = 0;
  saleValue: number = 0;
  cleaningValue: number = 0;
  minorRepairValue: number = 0;
  mayorRepairValue: number = 0;
  genericCode: number | null = null;
  conceptInvoicingCode: number | null = null;
  swPurchase: boolean = false;
  swSale: boolean = false;
  swRequiresPurchaseOrder: boolean = false;
  swRoutine: boolean = false;

  constructor(counter: number,
    articleCode: number,
    alterCode: string | null,
    alterCode2: string | null,
    name: string,
    familyCode: string,
    groupCode: string,
    subgroupCode: string,
    typeArticleId: number,
    typeInventoryCode: number,
    rentalUnitCode: string,
    inventoryUnitCode: string,
    occupancyPercentageReport: boolean,
    daysInConstructionSiteReport: boolean,
    weight: number = 0,
    areaM2: number = 0,
    observation: string | null,
    active: boolean,
    swAffectsInventory: boolean,
    swDirectDevolutionWorkshop: boolean,
    swEquipmentLogbook: boolean,
    replacementValue: number,
    saleValue: number,
    cleaningValue: number,
    minorRepairValue: number,
    mayorRepairValue: number,
    genericCode: number | null,
    conceptInvoicingCode: number | null,
    swPurchase: boolean,
    swSale: boolean,
    swRequiresPurchaseOrder: boolean,
    swRoutine: boolean,
  ) {
    this.counter = counter;
    this.articleCode = articleCode;
    this.alterCode = alterCode;
    this.alterCode2 = alterCode2;
    this.name = name;
    this.familyCode = familyCode;
    this.groupCode = groupCode;
    this.subgroupCode = subgroupCode;
    this.typeArticleId = typeArticleId;
    this.typeInventoryCode = typeInventoryCode;
    this.rentalUnitCode = rentalUnitCode;
    this.inventoryUnitCode = inventoryUnitCode;
    this.occupancyPercentageReport = occupancyPercentageReport;
    this.daysInConstructionSiteReport = daysInConstructionSiteReport;
    this.weight = weight;
    this.areaM2 = areaM2;
    this.observation = observation;
    this.active = active;
    this.swAffectsInventory = swAffectsInventory;
    this.swDirectDevolutionWorkshop = swDirectDevolutionWorkshop;
    this.swEquipmentLogbook = swEquipmentLogbook;
    this.replacementValue = replacementValue;
    this.saleValue = saleValue;
    this.cleaningValue = cleaningValue;
    this.minorRepairValue = minorRepairValue;
    this.mayorRepairValue = mayorRepairValue;
    this.genericCode = genericCode;
    this.conceptInvoicingCode = conceptInvoicingCode;
    this.swPurchase = swPurchase;
    this.swSale = swSale;
    this.swRequiresPurchaseOrder = swRequiresPurchaseOrder;
    this.swRoutine = swRoutine;
  }
}
